import { DISPLAY_CONTEXT_B2C_ONLY } from "../../constants";

export default function showFullDetails(testProduct) {
  return (
    testProduct.content.informationPanels.some(
      ({ displayContext }) => displayContext === DISPLAY_CONTEXT_B2C_ONLY
    ) || testProduct.content?.howItWorksPanel?.displayContext === DISPLAY_CONTEXT_B2C_ONLY
  );
}
